<script setup>
// import PostList from './components/PostList.vue'
// import TheWelcome from './components/TheWelcome.vue'
// import CreateForm from './components/CreateForm.vue'
import Anmeldung from './components/GWCD.vue'
//import Anmeldung from './components/BARBAROSSA.vue'
</script>

<template>
  <main>
    <Anmeldung />
  </main>
</template>

